import { apiRequest } from "@/services/api-client";
import { PlayerProfileOutput } from "types/web-app";

/**
 * Fetches player profile including poke_coins and poke_shards
 */
export const getPlayerProfile = (playerId?: string) => {
  const url = playerId
    ? `/player-profile?player_id=${playerId}`
    : "/player-profile";
  return apiRequest<PlayerProfileOutput>(url);
};
